import { render, staticRenderFns } from "./b2bordersubmission.vue?vue&type=template&id=ce6c87d8&scoped=true"
import script from "./b2bordersubmission.vue?vue&type=script&lang=js"
export * from "./b2bordersubmission.vue?vue&type=script&lang=js"
import style0 from "./b2bordersubmission.vue?vue&type=style&index=0&id=ce6c87d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6c87d8",
  null
  
)

export default component.exports